import {Injectable} from '@angular/core';
import {ParentAPIService} from './parent.api.service';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderActionService extends ParentAPIService {

  postSignoffSource = new BehaviorSubject<any>({});

  constructor(http: HttpClient) {
    super(http);
  }
}
